import { render, staticRenderFns } from "./ErrorsBag.vue?vue&type=template&id=2aeb8834&scoped=true"
import script from "./ErrorsBag.vue?vue&type=script&lang=js"
export * from "./ErrorsBag.vue?vue&type=script&lang=js"
import style0 from "./ErrorsBag.vue?vue&type=style&index=0&id=2aeb8834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb8834",
  null
  
)

export default component.exports